export default {
  root: "https://n5a69cecyj.execute-api.eu-west-1.amazonaws.com/beta/",
  endpoint: {
    ask: "ask",
    feedback: "feedback",
  },
};
